import React from 'react';
import { PopupOrPanel } from 'components/popupsAndPanels/PopupAndPanels';

type Props = {
  ipAddress: string;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const RemoveNetworkConfirm: React.FC<Props> = ({
  ipAddress,
  isSubmitting,
  onConfirm,
  onCancel,
}) => (
  <PopupOrPanel
    isPopup={true}
    isOpen={true}
    isSubmitting={isSubmitting}
    position="right"
    hdrTitle="Remove recognised network"
    primaryBtnTxt="Remove network"
    secondaryBtnTxt="Cancel"
    givenClass="ManageSchoolPopoutMenu SchoolMfaWarning"
    handleClose={onCancel}
    handlePrimaryBtn={onConfirm}
    handleSecondaryBtn={onCancel}
    width={560}
  >
    <p>
      Are you sure you want to remove <strong>{ipAddress}</strong>?
    </p>
    <p>Staff verifying from this network will be asked to verify more often.</p>
  </PopupOrPanel>
);

export default RemoveNetworkConfirm;
